import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { toast } from "@/components/ui/sonner";

export default function JoinLink() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { t } = useLang();
  const doneRef = useRef(false);

  useEffect(() => {
    if (doneRef.current) return;
    doneRef.current = true;
    (async () => {
      try {
        const { data } = await api.post("/rooms/join", { code: (code || "").toUpperCase() });
        navigate(`/room/${data.id}`, { replace: true });
      } catch (err) {
        toast.error(formatApiError(err.response?.data?.detail) || err.message);
        navigate("/lobby", { replace: true });
      }
    })();
  }, [code, navigate]);

  return (
    <div data-testid="join-link-page" className="min-h-screen bg-base flex items-center justify-center text-white/60 font-mono text-sm gap-2">
      <Loader2 className="w-4 h-4 animate-spin" /> {t("joining_table")} {code}
    </div>
  );
}
